import React, { Component  } from 'react'
import "./SuggestedSearchTerms.css"

const terms = ["Super Select", "Phantom", "Special Select", "Teryllium", "Select", "Futura", "GOLO", "Limited", "Classic", "Tour"];

function SuggestedSearchField(props) {
  return (
    <li key={props.value} className="suggest-search-word" onClick={props.onClick}>
      {props.value}
    </li>
  );
}

class SuggestedSearchTerms extends Component {

    renderSearchField(i) {
        return (
        <SuggestedSearchField
            value={i}
            onClick={() => this.props.onClick(i)}
            key={i}
        />
        );
    }

    render() {
        return (
            <div className="search-terms-list">
                <div className="header">QUICK LINKS FOR POPULAR SEARCHES:</div>
                <ul>
                    <SuggestedSearchField value="View All" onClick={this.props.onViewAll} /> 
                    {terms.map(function(t, index) {
                        return this.renderSearchField(t);
                    }, this)}
                </ul>
            </div>
        );
    }
}

export default SuggestedSearchTerms;